"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BeautyAndTrends = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../../hooks");
var _useTranslations = require("../../../hooks/useTranslations");
var _utils = require("../../../utils");
var _FindYourProductSkeleton = require("../FindYourProduct/FindYourProductSkeleton");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const analyticsData = url => () => {
  (0, _utils.logUserClick)(url);
};
const onEnterKeyPress = url => e => {
  if (e.key === 'Enter') {
    (0, _utils.logUserClick)(url);
  }
};
const BeautyAndTrends = ({
  content
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const isMobile = (0, _hooks.useIsMobile)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  if (!content || content.length === 0) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FindYourProductSkeleton.FindYourProductSkeleton, {
      animation: "pulse"
    });
  }
  if (isMobile) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
      "data-testid": getTestId(_constants.BEAUTY_AND_TRENDS_MOBILE),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.MobileList, {
        children: content.map(tile => tile.url && tile.title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BeautyLink, {
            "data-testid": getTestId(_constants.BEAUTY_AND_TRENDS_MOBILE_LINK),
            href: tile.url,
            onClick: analyticsData(tile.url),
            children: tile.title
          })
        }, tile.id) : null)
      })
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_constants.BEAUTY_AND_TRENDS),
    children: content.map(item => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      role: "button",
      tabIndex: 0,
      onClick: analyticsData(item.url),
      onKeyDown: onEnterKeyPress(item.url),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.CategoryBox, {
        size: _presentationComponents.CategoryBoxSize.MEDIUM,
        imageUrl: item.imageUrl,
        title: item.title,
        relativeUrl: item.url ?? '',
        buttonText: translations.view
      })
    }, item.id))
  });
};
exports.BeautyAndTrends = BeautyAndTrends;